import * as angular from "angular";
import {IController} from "angular";
import {$agentsFactory} from "../../$agents.factory";

export class agentsIndicatorCtrl implements IController {

  ids: any;

  private agentsRef: any;
  private agents = [];

  /* @ngInject */
  constructor(private $agents: $agentsFactory) {
    this.agentsRef = this.$agents();
  }

  $onInit() {
    if (this.ids) {
      this.agentsRef.$asyncValues(this.ids)
        .then((agents) => {
          this.agents = agents;
        })
    }
  }

  $onChanges(changes) {
    if (changes.ids && !changes.ids.isFirstChange()) {
      this.agents = [];

      if (this.agents) {
        this.$onInit();
      }
    }
  }
}

angular
  .module('bringoz.admin.agents')
  .component('agentsIndicator', {
    bindings: {
      ids: '<'
    },
    template: require('./agents-indicator.html').default,
    controller: agentsIndicatorCtrl
  });
